/**
 * Scroll the viewer to a page by its ORIGINAL index. Pages render with a
 * `data-page-index` attribute (the original index, stable across reorder), so
 * both the thumbnail rail and search results can jump to a page the same way.
 */
export function scrollToPageIndex(originalIndex: number): void {
  const el = document.querySelector(`[data-page-index="${originalIndex}"]`);
  if (el instanceof HTMLElement) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
